import { render, staticRenderFns } from "./AlertContacts.vue?vue&type=template&id=71d76852&scoped=true"
import script from "./AlertContacts.vue?vue&type=script&lang=js"
export * from "./AlertContacts.vue?vue&type=script&lang=js"
import style0 from "./AlertContacts.vue?vue&type=style&index=0&id=71d76852&prod&scoped=true&lang=css"
import style1 from "./AlertContacts.vue?vue&type=style&index=1&id=71d76852&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d76852",
  null
  
)

export default component.exports